import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeNavigationService } from '../home-navigation.service';
import { Router, NavigationEnd, ActivatedRoute, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
@Component({
selector:'app-root',
standalone:true,
imports:[CommonModule,RouterOutlet,RouterLink,RouterLinkActive],
template:
`
  <div class="shell">
    <div class="top">

      <a href="https://wa.me/27773762687"
        class="nav"
        [class.active]="whatsappActive"
        (click)="setWhatsappActive()">
        <img src="assets/images/WhatsAppV1.png"
          class="top-img nav-img">
      </a>

      <div class="logo">
        <img src="assets/images/WalletyLogo.png" class="logo-img">
      </div>

      <div class="profile-space">
        <a *ngIf="false && hasSession && !hideNavigation"
          routerLink="/profile"
          routerLinkActive="active"
          class="nav">
          <img src="assets/images/Account.png"
            class="top-img nav-img">
        </a>
      </div>
    </div>

    <div class="page-content">
      <router-outlet></router-outlet>
    </div>

    <div class="bottom" *ngIf="hasSession && !hideNavigation">
      <a
        class="nav"
        [class.active]="homeSelected"
        (click)="goHome()">
        <img src="assets/images/Home.png" class="nav-img">
      </a>

      <a class="nav" (click)="requestHelp()">
        <img src="assets/images/Help.png" class="nav-img">
      </a>

      <a *ngIf="false" routerLink="/contacts"
        routerLinkActive="active"
        class="nav">
        <img src="assets/images/Contact.png" class="nav-img">
      </a>

      <a class="nav" (click)="requestLogout()">
        <img src="assets/images/Logout.png" class="nav-img">
      </a>
    </div>

    <div class="overlay" *ngIf="showAlert">
      <div class="alert-modal">
        <div class="alert-text">
          {{alertMessage}}
        </div>
         <div class="btns" *ngIf="!isLoading">
          <button class="cancel"
            (click)="closeAlert()">
            {{alertCloseButtonText}}
          </button>
          <button
            class="primary"
            (click)="logout()">
            {{alertConfirmButtonText}}
          </button>
        </div>
        <div class="spinner-container" *ngIf="isLoading">
          <span class="spinner"></span>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="showHelpAlert">
      <div class="alert-modal">
        <div class="alert-text">
          {{alertMessage}}
        </div>
        <div class="btns" *ngIf="!isLoading">
          <button class="cancel"
           (click)="closeAlert()">
            {{alertCloseButtonText}}
          </button>
          <button
            class="primary"
            (click)="help()">
            Proceed
          </button>
        </div>
        <div class="spinner-container" *ngIf="isLoading">
          <span class="spinner"></span>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
      </div>
    </div>
  `
})
export class AppComponent{
    isLoading = false;
  constructor(public router: Router, 
              private route: ActivatedRoute, 
              private homeNavigation: HomeNavigationService,
              private sessionService: SessionService,
              private authService: AuthService,) {}

  get hideNavigation(): boolean {
    const hiddenRoutes = [
      '/login',
      '/setsecurityquestions',
      '/setauthorizationpin',
      '/unlockaccount',
      '/forgotpin',
      '/walletymepayment'
    ];
    return hiddenRoutes.some(route => this.router.url.startsWith(route));
  }
  hasSession = false;
  ngOnInit() {
    this.sessionService.hasSession$
    .subscribe(value => {
        this.hasSession = value;
    });

      this.homeNavigation.tabSelected$
    .subscribe(tab => {
      this.homeSelected = tab === 'History';
    });
  }
  // =====================================================
  // 
  // =====================================================
  errorMessage = '';
  homeSelected = false;
  whatsappActive = false;
  showAlert = false;
  alertMessage = '';
  alertConfirmButtonText = '';
  alertCloseButtonText = '';
  showErrorPopup = false;
  whatsAppUrl = environment.whatsapp_url;
  showHelpAlert = false;

  goHome() {
     // this.homeSelected = true;
  this.router.navigateByUrl('/').then(() => {
    this.homeNavigation.selectTab('History');
  });
}
  setWhatsappActive(){
    this.whatsappActive = true;
  }
  requestLogout(){
    this.alertConfirmButtonText = 'Yes';
    this.alertCloseButtonText = 'No';
    this.showAlert = true;
    this.alertMessage = 'Are you sure you want to logout?';
  }
  help(){
    this.isLoading = true;
     let userSession = this.sessionService.getSession();
     if(!userSession)
      return;
    this.authService
      .postHelp(userSession)
      .subscribe({
          next: response => {
            this.isLoading = false;
              this.showAlert = false;
              this.sessionService.clear();
              window.location.href = this.whatsAppUrl;
          },
          error: err => {
            this.isLoading = false;
             if (err.status === 401) {
                this.showAlert = false;
                this.sessionService.clear();
                window.location.href = this.whatsAppUrl;
             }
            this.showAlert = false;
            this.errorMessage = err.error?.message ?? 'Failed to logout.';
            this.showErrorPopup = true;
            setTimeout(()=> this.showErrorPopup = false, 1500);
          }
        },
      );
  }
  requestHelp(){
  this.alertConfirmButtonText = 'Proceed';
    this.alertCloseButtonText = 'Cancel';
    this.showHelpAlert = true;
this.alertMessage = 'For the quickest response, please send a WhatsApp message describing your issue in detail, and a support agent will be with you. Support hours: Monday–Friday, 09:00–17:00 | Saturday, 09:00–14:00 | Sunday and public holidays: Closed.';
  }
  closeAlert(){
    this.showAlert = false;
    this.showHelpAlert = false;
  }
  logout(){
    this.isLoading = true;
     let userSession = this.sessionService.getSession();
     if(!userSession)
      return;
    this.authService
      .postLogout(userSession)
      .subscribe({
          next: response => {
              this.showAlert = false;
              this.sessionService.clear();
              window.location.href = this.whatsAppUrl;
          },
          error: err => {
             if (err.status === 401) {
                this.showAlert = false;
                this.sessionService.clear();
                window.location.href = this.whatsAppUrl;
             }
            this.showAlert = false;
            this.isLoading = false;
            this.errorMessage = err.error?.message ?? 'Failed to logout.';
            this.showErrorPopup = true;
            setTimeout(()=> this.showErrorPopup = false, 1500);
          }
        },
      );
  }
}
